import styles from "./servico-detalhe-cover.module.css";
import coverImg from "../../../images/_finais/servicos-detalhe-cover_compress.webp";

interface IProps {
  title: string;
  alt: string;
}

const ServicoDetalheCover = ({ title, alt }: IProps) => {
  return (
    <section className={styles.cover_section}>
      <div className={styles.title_div}>
        <h1 className={styles.title}>{title}</h1>
        <span className={styles.line}></span>
      </div>
      <img
        className={styles.coverImg}
        src={coverImg}
        alt={alt}
        loading="lazy"
      />
    </section>
  );
};

export default ServicoDetalheCover;
